import { BASEURL } from "../../API/apiData";
import axios from "axios";

const fetchProjectAssumptions = async (projectID) => {
  const token = localStorage.getItem("token");
  try {
    const result = await axios.get(
      `${BASEURL}projects/${projectID}/project_assumptions`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result.data;
  } catch (error) {
    return error;
  }
};

const createProjectAssumptions = async (data) => {
  const token = localStorage.getItem("token");
  const { projectID, assumptionData } = data;
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(assumptionData),
    };
    const response = await fetch(
      `${BASEURL}projects/${projectID}/project_assumptions`,
      requestOptions
    );
    const results = response.json();
    return results;
  } catch (error) {
    return error;
  }
};

const editProjectAssumption = async (data) => {
  const token = localStorage.getItem("token");
  const { projectID, assumptionID, assumptionData } = data;
  try {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(assumptionData),
    };

    const result = await fetch(
      `${BASEURL}projects/${projectID}/project_assumptions/${assumptionID}`,
      requestOptions
    );
    const results = result.json();
    return results;
  } catch (error) {
    return error;
  }
};

const upvoteProjectAssumption = async (data) => {
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(`${BASEURL}upvotes`, requestOptions);
  const results = await response.json();
  return results;
};

const unvoteProjectAssumption = async (data) => {
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(`${BASEURL}unvote`, requestOptions);
  const results = await response.json();
  return results;
};

const createProjectAssumptionComment = async (data) => {
  const { project_id, project_assumption_id, commentData } = data;
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentData),
  };
  const response = await fetch(
    `${BASEURL}projects/${project_id}/project_assumptions/${project_assumption_id}/project_assumption_comments`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const fetchProjectAssumptionComment = async (data) => {
  const { project_id, project_assumption_id } = data;
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(
    `${BASEURL}projects/${project_id}/project_assumptions/${project_assumption_id}`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const editProjectAssumptionComment = async (data) => {
  const { project_id, project_assumption_id, id, commentData } = data;
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentData),
  };
  const response = await fetch(
    `${BASEURL}projects/${project_id}/project_assumptions/${project_assumption_id}/project_assumption_comments/${id}`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const createProjectAssumptionCommentResponses = async (data) => {
  const {
    project_id,
    project_assumption_id,
    project_assumption_comment_id,
    commentData,
  } = data;
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentData),
  };
  const response = await fetch(
    `${BASEURL}projects/${project_id}/project_assumptions/${project_assumption_id}/project_assumption_comments/${project_assumption_comment_id}/project_assumption_comment_replies`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const editProjectAssumptionCommentResponses = async (data) => {
  const {
    project_id,
    project_assumption_id,
    project_assumption_comment_id,
    commentData,
    id,
  } = data;
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentData),
  };
  const response = await fetch(
    `${BASEURL}projects/${project_id}/project_assumptions/${project_assumption_id}/project_assumption_comments/${project_assumption_comment_id}/project_assumption_comment_replies/${id}`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const createNewAssumptionsReplyOfReply = async (data) => {
  const token = localStorage.getItem("token");
  const {
    projectID,
    assumptionID,
    projectAssumptionCommentID,
    projectCommentReplyID,
    commentReplyOfReply,
  } = data;
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentReplyOfReply),
  };
  const response = await fetch(
    `${BASEURL}projects/${projectID}/project_assumptions/${assumptionID}/project_assumption_comments/${projectAssumptionCommentID}/project_assumption_comment_replies/${projectCommentReplyID}/project_assumption_comment_response_of_responses`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const editAssumptionReplyOfReplyComment = async (data) => {
  const token = localStorage.getItem("token");
  const {
    projectID,
    assumptionID,
    projectAssumptionCommentID,
    projectCommentReplyID,
    ID,
    commentReplyOfReplyEdit,
  } = data;
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(commentReplyOfReplyEdit),
  };
  const response = await fetch(
    `${BASEURL}projects/${projectID}/project_assumptions/${assumptionID}/project_assumption_comments/${projectAssumptionCommentID}/project_assumption_comment_replies/${projectCommentReplyID}/project_assumption_comment_response_of_responses/${ID}`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

export {
  fetchProjectAssumptions,
  createProjectAssumptions,
  editProjectAssumption,
  upvoteProjectAssumption,
  unvoteProjectAssumption,
  createProjectAssumptionComment,
  fetchProjectAssumptionComment,
  editProjectAssumptionComment,
  createProjectAssumptionCommentResponses,
  editProjectAssumptionCommentResponses,
  createNewAssumptionsReplyOfReply,
  editAssumptionReplyOfReplyComment,
};
